/**
 * Sidebar Return reason filter: binds RmaListFiltersStore return-reason draft to
 * RmaListFilterControl via filterControlDataProps (single-select radio list).
 */
import { observer } from "mobx-react";
import useDashboardTranslation from "../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import RmaListFiltersStore from "../../../../../rma-list-page/stores/rma-list-filters-store";
import {
    MANAGE_RETURNS_DESIGN_VERSION,
    trackManageReturnsListEvent,
} from "../../../../../utils/manage-returns-list-mixpanel";
import { RMA_LIST_FILTER_CONTROL_DATA_TYPE } from "../rma-list-filter-control/components/rma-list-filter-control-portal/rma-list-filter-control-content/rma-list-filter-control-content";
import RmaListFilterControl from "../rma-list-filter-control/rma-list-filter-control";

interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
    disabled?: boolean;
}

const RmaListFilterReturnReason: React.FC<IProps> = observer(({ rmaListFiltersStore, disabled }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";
    const selectedId = rmaListFiltersStore.selectedReturnReasonId;

    return (
        <RmaListFilterControl
            label={getTranslation("FILTERS_RETURN_REASON", scope)}
            selectedLabel={rmaListFiltersStore.selectedReturnReasonLabel}
            disabled={disabled}
            onOpen={() => trackManageReturnsListEvent("d&_filter_return_reason", MANAGE_RETURNS_DESIGN_VERSION.V2)}
            onClear={() => rmaListFiltersStore.setSelectedReturnReasonId(null)}
            filterControlDataProps={{
                type: RMA_LIST_FILTER_CONTROL_DATA_TYPE.OPTIONS,
                value: selectedId,
                options: rmaListFiltersStore.returnReasonFilterOptions,
                onChange: (id) => {
                    rmaListFiltersStore.setSelectedReturnReasonId(Number(id));
                },
            }}
        />
    );
});

export default RmaListFilterReturnReason;
